import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from 'react-redux'
import {createTheme, MuiThemeProvider} from "@material-ui/core/styles";
import {tableTheme} from "../../components/customTable/TableTheme";
import ActionsOptions from "../../components/customTable/ActionsOptions";
import ActionsWrapper from "../../components/customTable/ActionsWrapper";
import EditButton from "../../components/customTable/EditButton";
import {publishingHouseActions} from "../../store/publishingHouse/publishingHouseSlice";
import DeleteButton from "../../components/customTable/DeleteButton";
import SearchButton from "../../components/customTable/SearchButton";
import FilterButton from "../../components/customTable/FilterButton";
import {StaticTableOptions} from "../../components/customTable/StaticTableOptions";
import AddButton from "../../components/customTable/AddButton";
import {addPublishingHouseData, deletePublishingHouseData, fetchPublishingHouseData, updatePublishingHouseData} from "../../store/publishingHouse/publishingHouseActions";
import MUIDataTable from "mui-datatables";
import DeleteDialog from "../../components/dialogs/DeleteDialog";
import AddDialog from "../../components/dialogs/AddDialog";
import DialogHeader from "../../components/dialogs/DialogHeader";
import TextInput from "../../components/textInput/TextInput";

function PublishingHouses({ getMuiTheme = () => createTheme(tableTheme) }) {

    const dispatch = useDispatch()
    const language = useSelector(state => state.userInfos.language)
    const publishingHouses = useSelector(state => state.publishingHouses.publishingHouses)
    const isPublishingHouse = useSelector(state=>state.publishingHouses.publishingHouse)
    const TableOptions = useSelector(state => state.tableOptions.options)
    const [openAdd, setOpenAdd] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const [publishingHouseId, setPublishingHouseId] = useState(false)

    const cancelAddRef = useRef(null)
    const cancelDeleteRef = useRef(null)

    const [publishingHouse, setPublishingHouse] = useState({})

    const cols = [
        {
            name: "name",
            label: language.publishing_house_name,
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta) => {
                    return (
                        <div>{value}</div>
                    );
                }
            }
        },
        {
            name: "",
            options: {
                ...ActionsOptions,
                customBodyRender: (value, tableMeta, rowIndex) => {
                    return (
                        <ActionsWrapper>
                            <EditButton
                                onClick={() => {
                                    setPublishingHouseId(publishingHouses[tableMeta.rowIndex].id)
                                    setOpenEdit(true)
                                    setOpenAdd(true)
                                    setPublishingHouse(publishingHouses[tableMeta.rowIndex])
                                    dispatch(publishingHouseActions.getPublishingHouse(publishingHouses[tableMeta.rowIndex]))
                                }}
                            />
                            <DeleteButton
                                onClick={() => {
                                    setPublishingHouseId(publishingHouses[tableMeta.rowIndex].id)
                                    dispatch(publishingHouseActions.getPublishingHouse(publishingHouses[tableMeta.rowIndex]))
                                    setOpenDelete(true)
                                }
                                }
                            />
                        </ActionsWrapper>
                    );
                }
            }
        }];

    const components = {
        icons: {
            SearchIcon: SearchButton,
            ViewColumnIcon: FilterButton,
        }
    }

    const options = {
        ...TableOptions, ...StaticTableOptions,
        selectableRows: "multiple",
        customToolbar: () => {
            return (
                <AddButton onClick={() => {
                    setOpenAdd(true)
                    setOpenEdit(false)
                }} />
            )
        }
    }

    const savePublishingHouse = () => {
        dispatch(publishingHouseActions.getPublishingHouse(''))
        dispatch(addPublishingHouseData(publishingHouse.name))
        dispatch(fetchPublishingHouseData())
        setOpenAdd(false)
    }

    const deletePublishingHouse = () => {
        dispatch(deletePublishingHouseData(publishingHouseId))
        dispatch(fetchPublishingHouseData())
        setOpenDelete(false)
    }

    const editPublishingHouse = () => {
        dispatch(updatePublishingHouseData(publishingHouseId, publishingHouse.name))
        dispatch(fetchPublishingHouseData())
        setOpenEdit(false)
        setOpenAdd(false)
    }

    useEffect(() => {
        dispatch(fetchPublishingHouseData())
    }, [dispatch,isPublishingHouse])

    return (
        <div>
            <div className="container mt-3 px-3 mx-auto max-w-screen-lg data-table">
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        className="w-full z-0"
                        title={language.publishingHouses}
                        data={publishingHouses}
                        columns={cols}
                        options={options}
                        components={components}
                    />
                </MuiThemeProvider>
            </div>
            <DeleteDialog
                openDelete={openDelete}
                cancelDeleteRef={cancelDeleteRef}
                setOpenDelete={setOpenDelete}
                deleteItem={deletePublishingHouse}
                title={language.delete_publishing_house}
                warning={language.publishing_house_delete_warning}
            />
            <AddDialog
                isEdit={openEdit}
                openAdd={openAdd}
                setOpenEdit={setOpenEdit}
                setOpenAdd={setOpenAdd}
                cancelAddRef={cancelAddRef}
                saveItem={savePublishingHouse}
                editItem={editPublishingHouse}
            >
                <DialogHeader
                    closeModal={() => setOpenAdd(false)}
                    title={openEdit ? language.edit_publishing_house : language.add_publishing_house}
                />
                <TextInput
                    label={language.publishing_house_name}
                    value={openEdit ? publishingHouse.name : null}
                    onChange={(e) => setPublishingHouse({ ...publishingHouse, name: e.target.value })}
                    placeholder={language.publishing_house_name}
                />
            </AddDialog>
        </div>
    );
}

export default PublishingHouses;